module.exports = __webpack_public_path__ + "static/img/done.51d234a.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/done.png
// module id = 9TBh
// module chunks = 21